import React from 'react';
import { Text, View, Svg, Path, G, Rect, Circle } from '@react-pdf/renderer';

const IUserReview = () => {
    return (
        <Svg viewBox="0 0 512 472">
            <G transform="translate(4.837 23.217)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M442.48,317.47c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-53.23H69.86v53.23   c0.33,5.55-3.89,10.31-9.44,10.64c-0.4,0.02-0.8,0.02-1.2,0c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-63.83   c-0.36-5.54,3.84-10.33,9.38-10.69c0.42-0.03,0.83-0.03,1.25,0h383.27c5.55-0.33,10.31,3.89,10.64,9.44c0.02,0.4,0.02,0.8,0,1.2   v63.83c0.36,5.54-3.84,10.33-9.38,10.69C443.32,317.49,442.9,317.49,442.48,317.47z"
                />
            </G>
            <G transform="translate(22.249 14.51)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M233.42,326.16c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-159.7   c0-5.88,4.77-10.65,10.65-10.65s10.65,4.77,10.65,10.65v159.69c0.34,5.55-3.88,10.31-9.43,10.65   C234.24,326.19,233.83,326.19,233.42,326.16z"
                />
            </G>
            <G transform="translate(20.315 32.89)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M235.35,392.91c-17.63,0.01-31.92-14.27-31.93-31.9c-0.01-17.63,14.27-31.92,31.9-31.93   c0.01,0,0.03,0,0.04,0c17.63,0.01,31.91,14.31,31.9,31.93C267.23,378.63,252.96,392.9,235.35,392.91z M235.35,350.33   c-5.88,0-10.64,4.76-10.64,10.64s4.76,10.64,10.64,10.64c5.88,0,10.64-4.76,10.64-10.64l0,0c0.31-5.55-3.94-10.29-9.49-10.6   c-0.38-0.02-0.77-0.02-1.16,0V350.33z"
                />
            </G>
            <G transform="translate(17.413 40.629)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M291.5,470.34c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-10.64   c0.67-11.09-7.78-20.62-18.87-21.3c-0.81-0.05-1.62-0.05-2.43,0h-42.59c-11.09-0.67-20.62,7.78-21.3,18.87   c-0.05,0.81-0.05,1.62,0,2.43v10.64c0.33,5.55-3.89,10.31-9.44,10.64c-0.4,0.02-0.8,0.02-1.2,0c-5.55,0.33-10.31-3.9-10.64-9.44   c-0.02-0.38-0.02-0.77,0-1.16V449.1c0.07-23.49,19.09-42.52,42.58-42.59h42.58c23.49,0.07,42.51,19.09,42.58,42.58v10.64   c0.31,5.55-3.93,10.3-9.48,10.61C292.27,470.37,291.89,470.37,291.5,470.34z"
                />
            </G>
            <G transform="translate(37.727 32.89)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M409.56,392.91c-17.63,0-31.92-14.29-31.92-31.92c0-17.63,14.29-31.92,31.92-31.92   c17.63,0,31.92,14.29,31.92,31.92c0,0,0,0,0,0C441.04,378.44,427,392.47,409.56,392.91z M409.56,350.33   c-5.88,0-10.64,4.76-10.64,10.64c0,5.88,4.76,10.64,10.64,10.64c5.88,0,10.64-4.76,10.64-10.64c0.31-5.55-3.94-10.29-9.49-10.6   c-0.39-0.02-0.77-0.02-1.16,0V350.33z"
                />
            </G>
            <G transform="translate(34.825 40.629)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M465.72,470.34c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-10.64   c0.67-11.09-7.78-20.62-18.87-21.3c-0.81-0.05-1.62-0.05-2.43,0h-42.59c-11.09-0.67-20.62,7.78-21.3,18.87   c-0.05,0.81-0.05,1.62,0,2.43v10.64c0,5.88-4.77,10.65-10.65,10.65c-5.88,0-10.65-4.77-10.65-10.65v-10.64   c0.09-23.48,19.11-42.48,42.59-42.55h42.58c23.49,0.07,42.51,19.09,42.58,42.58v10.64c0.31,5.55-3.93,10.3-9.48,10.61   C466.49,470.37,466.1,470.37,465.72,470.34z"
                />
            </G>
            <G transform="translate(2.902 32.89)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M61.12,392.91c-17.63-0.01-31.91-14.31-31.9-31.93c0.01-17.61,14.28-31.89,31.9-31.9   c17.63,0.01,31.91,14.31,31.9,31.93C93.01,378.63,78.73,392.9,61.12,392.91z M61.12,350.33c-5.88,0-10.65,4.77-10.65,10.65   c0,5.88,4.77,10.65,10.65,10.65s10.65-4.77,10.65-10.65C71.77,355.1,67,350.33,61.12,350.33z"
                />
            </G>
            <G transform="translate(0 40.629)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M117.28,470.34c-5.55,0.33-10.31-3.89-10.64-9.44c-0.02-0.4-0.02-0.8,0-1.2v-10.64   c0.67-11.09-7.78-20.62-18.87-21.3c-0.81-0.05-1.62-0.05-2.43,0H42.75c-11.09-0.67-20.62,7.78-21.3,18.87   c-0.05,0.81-0.05,1.62,0,2.43v10.64c0.33,5.55-3.89,10.31-9.44,10.64c-0.4,0.02-0.8,0.02-1.2,0c-5.55,0.33-10.31-3.9-10.64-9.44   c-0.02-0.38-0.02-0.77,0-1.16V449.1c0.07-23.49,19.09-42.52,42.58-42.59h42.59c23.49,0.07,42.51,19.09,42.58,42.58v10.64   c0.31,5.55-3.93,10.3-9.47,10.61C118.06,470.37,117.67,470.37,117.28,470.34z"
                />
            </G>
            <G transform="translate(13.543 0)">
                <Path
                    stroke={'red'}
                    strokeWidth={1}
                    d="M182.51,212.92c-2.12,0-4.26,0-4.26-2.12c-3.99-2.04-6.46-6.17-6.38-10.64l10.64-63.83   L137.8,91.56c-1.93-3.19-2.68-6.96-2.12-10.64c2.12-4.26,4.26-6.38,8.52-6.38l61.75-10.7l27.68-57.45c0-4.26,4.26-6.38,8.52-6.38   c4.48-0.08,8.61,2.4,10.64,6.38l25.55,57.45l59.62,8.52c4.26,0,6.38,4.26,8.52,6.38s0,8.52-2.12,10.64l-44.69,44.77l10.64,63.83   c0,4.26,0,8.52-4.26,10.64c-3.22,2.17-7.43,2.17-10.64,0l-53.23-27.68l-53.23,29.81c-1.7,1.63-4.04,2.41-6.38,2.12L182.51,212.92z    M167.59,91.56l34.12,34.12c2.12,2.12,4.26,6.38,2.12,8.52l-6.38,48.97l40.43-21.38c3.22-2.17,7.43-2.17,10.64,0l40.46,21.3   l-8.52-46.84c0-4.26,0-6.38,2.12-8.52L316.7,93.6l-44.71-6.38c-4.26,0-6.38-2.12-8.52-6.38l-19.2-42.5L225.1,80.91   c-3.95,0.08-7.73,1.6-10.64,4.26L167.59,91.56z"
                />
            </G>
        </Svg>
    );
};

const IChatUser = () => {
    return (
        <Svg viewBox="0 0 512 365">
            <G transform="translate(-601.07 -3554.508)">
                <G transform="translate(601.07 3480.971)">
                    <Path
                        stroke={'#6b79f7'}
                        strokeWidth={1}
                        d="M480.22,75.54H152.82c-5.58,0-10.11,4.52-10.11,10.11c0,5.58,4.52,10.11,10.11,10.11h327.41    c5.58,0,10.11,4.52,10.11,10.11l0,0v238.96c0,5.58-4.52,10.11-10.11,10.11h0H303.18c-3.1,0-6.02,1.42-7.94,3.85l-40.78,51.65    l-43.25-51.88c-1.92-2.31-4.77-3.64-7.77-3.64H31.15c-5.58,0-10.11-4.52-10.11-10.11l0,0V105.87c0-5.58,4.52-10.11,10.11-10.11    c0,0,0,0,0,0h38.49c5.58,0,10.11-4.52,10.11-10.11c0-5.58-4.52-10.11-10.11-10.11l0,0H31.15c-16.74,0-30.32,13.57-30.32,30.32    v238.94c0,16.74,13.57,30.32,30.32,30.32h167.56l48.21,57.82c3.63,4.29,10.04,4.83,14.34,1.21c0.51-0.43,0.97-0.9,1.38-1.42    l45.47-57.61h172.12c16.74,0,30.32-13.57,30.32-30.32V105.87c0.01-16.74-13.56-30.32-30.31-30.33    C480.23,75.54,480.23,75.54,480.22,75.54z"
                    />
                    <Path
                        stroke={'#6b79f7'}
                        strokeWidth={1}
                        d="M56.82,205.63c-1.07,3.3-0.38,6.91,1.83,9.58l19.68,23.77l-1.95,30.8    c-1.54,24.13,34.69-1.49,42.5-1.34c7.82,0.16,44.03,25.2,42.5,1.34l-1.95-30.8l19.68-23.77c3.52-4.44,2.78-10.88-1.66-14.4    c-1.07-0.85-2.3-1.48-3.62-1.84l-29.89-7.66l-16.52-26.06c-3.13-4.72-9.5-6-14.21-2.87c-1.14,0.76-2.11,1.73-2.87,2.87    L93.83,191.3l-29.89,7.66C60.58,199.82,57.89,202.33,56.82,205.63z M102.72,209.9c7.48-1.91,12.35-14.42,16.16-20.36    c3.71,5.84,8.76,18.47,16.16,20.36l18.33,4.69l-12.07,14.6c-1.64,1.98-2.46,4.52-2.3,7.09l1.2,18.89l-17.58-6.97    c-2.39-0.95-5.06-0.95-7.46,0l-17.58,6.97l1.2-18.89c0.16-2.57-0.66-5.1-2.3-7.09l-12.07-14.6L102.72,209.9z"
                    />
                    <Path
                        stroke={'#6b79f7'}
                        strokeWidth={1}
                        d="M316.75,205.63c-1.07-3.29-3.75-5.81-7.11-6.67l-29.89-7.66l-16.52-26.06    c-3.13-4.72-9.5-6-14.21-2.87c-1.14,0.76-2.11,1.73-2.87,2.87l-16.52,26.06l-29.89,7.66c-5.41,1.38-8.67,6.88-7.3,12.29    c0.37,1.45,1.06,2.8,2.02,3.96l19.68,23.77l-1.95,30.8c-1.54,24.13,34.69-1.49,42.5-1.34c7.82,0.16,44.03,25.2,42.5,1.34    l-1.95-30.8l19.68-23.77C317.14,212.54,317.82,208.93,316.75,205.63z M277.1,229.21c-1.64,1.98-2.46,4.52-2.3,7.09l1.2,18.89    c-6.62-3.76-13.84-6.36-21.34-7.69c-7.5,1.34-14.71,3.94-21.34,7.69l1.2-18.89c0.16-2.57-0.66-5.1-2.3-7.09l-12.07-14.6    l18.33-4.69c7.48-1.91,12.35-14.42,16.16-20.36c3.71,5.84,8.76,18.47,16.16,20.36l18.33,4.69L277.1,229.21z"
                    />
                    <Path
                        stroke={'#6b79f7'}
                        strokeWidth={1}
                        d="M452.54,205.63c-1.07-3.29-3.75-5.81-7.11-6.67l-29.9-7.66l-16.52-26.06    c-3.13-4.72-9.5-6-14.21-2.87c-1.14,0.76-2.11,1.73-2.87,2.87l-16.52,26.06l-29.89,7.66c-5.45,1.52-8.64,7.17-7.12,12.63    c0.37,1.32,0.99,2.55,1.85,3.62l19.68,23.77l-1.95,30.8c-1.54,24.13,34.68-1.49,42.5-1.34c7.83,0.16,44.03,25.2,42.5,1.34    l-1.95-30.8l19.68-23.77C452.92,212.54,453.61,208.93,452.54,205.63z M412.89,229.21c-1.64,1.98-2.46,4.52-2.3,7.09l1.2,18.89    l-17.58-6.97c-2.39-0.95-5.06-0.95-7.46,0l-17.58,6.97l1.2-18.89c0.16-2.57-0.66-5.1-2.3-7.09l-12.07-14.6l18.33-4.69    c7.48-1.91,12.35-14.42,16.16-20.36c3.71,5.84,8.76,18.47,16.16,20.36l18.33,4.69L412.89,229.21z"
                    />
                    <Path
                        stroke={'#6b79f7'}
                        strokeWidth={1}
                        d="M105.84,94.05c4.64,3.1,10.92,1.85,14.02-2.79c3.1-4.64,1.85-10.92-2.79-14.02    s-10.92-1.85-14.02,2.79c-0.41,0.62-0.76,1.28-1.03,1.98C100.35,86.42,101.93,91.41,105.84,94.05z"
                    />
                </G>
            </G>
        </Svg>
    );
};

const ISourceReview = () => {
    return (
        <Svg viewBox="0 0 512 489">
            <G transform="translate(0 -1)">
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M308.62,490h-21.17c-17.53-0.02-31.75-14.23-31.76-31.76V352.37   c0.02-17.53,14.23-31.75,31.76-31.76h21.18c17.53,0.02,31.75,14.23,31.76,31.76v105.87C340.37,475.78,326.16,489.99,308.62,490z    M287.44,341.74c-5.84,0.02-10.57,4.75-10.58,10.58v105.87c0.02,5.84,4.75,10.57,10.58,10.58h21.18   c5.84-0.02,10.57-4.75,10.58-10.58V352.37c-0.02-5.84-4.75-10.57-10.58-10.58L287.44,341.74z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M446.26,490h-16.09c-57.17,0-90.71-14.27-105.61-22.73c-4.93-3.17-6.35-9.73-3.19-14.66   c2.93-4.56,8.84-6.18,13.68-3.74c10.52,6.04,40.89,20.01,95.12,20.01h16.09c14.89,0.02,27.72-10.47,30.66-25.06   c0.04-0.31,0.11-0.63,0.19-0.93c1.31-6.37,11.22-65.37,11.51-71.43c-0.11-16.41-13.44-29.66-29.86-29.66h-58.22   c-5.85,0.01-10.6-4.72-10.62-10.57c0-2.12,0.63-4.19,1.81-5.94c5.63-10.33,8.44-21.95,8.15-33.71c0-21.14-8.47-28.8-14.19-28.8   c-1.97,0.27-4.21,3.25-4.21,19.06c0,32.85-32.67,56.76-46.71,65.51c-4.9,3.18-11.45,1.79-14.63-3.1c-3.18-4.9-1.79-11.45,3.1-14.63   c0.11-0.07,0.21-0.14,0.32-0.2c8.66-5.41,36.74-24.71,36.74-47.55c0-13.06,0-40.23,25.39-40.23c17.05,0,35.36,15.63,35.36,49.97   c0.03,9.84-1.44,19.62-4.38,29h42.08c28.17,0.03,51,22.86,51.03,51.03c0,0.68-2.63,53.81-12.91,75.44l0.93,0.17   C493.25,472.1,471.53,490.11,446.26,490z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M393.37,151.26H75.72c-40.94,0-74.13-33.19-74.13-74.13S34.77,3,75.72,3h317.65   c40.94,0,74.13,33.19,74.13,74.13S434.31,151.26,393.37,151.26z M75.72,24.18c-29.24,0-52.94,23.7-52.94,52.94   s23.7,52.94,52.94,52.94h317.65c29.24,0,52.94-23.7,52.94-52.94s-23.7-52.94-52.94-52.94L75.72,24.18z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M96.9,108.87c-17.54,0-31.76-14.22-31.76-31.76S79.35,45.35,96.9,45.35s31.76,14.22,31.76,31.76   C128.64,94.65,114.43,108.86,96.9,108.87z M96.9,66.53c-5.85,0-10.58,4.74-10.58,10.58s4.74,10.58,10.58,10.58   c5.85,0,10.58-4.74,10.58-10.58C107.46,71.27,102.73,66.54,96.9,66.53z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M202.76,108.87c-17.54,0-31.76-14.22-31.76-31.76s14.22-31.76,31.76-31.76   s31.76,14.22,31.76,31.76v0C234.5,94.65,220.29,108.86,202.76,108.87z M202.76,66.53c-5.85,0-10.58,4.74-10.58,10.58   c0,5.85,4.74,10.58,10.58,10.58s10.58-4.74,10.58-10.58l0,0C213.33,71.27,208.6,66.54,202.76,66.53z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M308.63,278.31H75.72c-40.94,0-74.13-33.19-74.13-74.13s33.19-74.13,74.13-74.13h317.65   c40.91,0.04,74.07,33.2,74.11,74.11c0.07,8.11-1.3,16.17-4.05,23.81c-2.08,5.46-8.19,8.21-13.66,6.13   c-5.39-2.05-8.14-8.03-6.2-13.46c1.86-5.28,2.79-10.85,2.73-16.45c-0.04-29.22-23.71-52.91-52.93-52.96H75.72   c-29.24,0-52.94,23.7-52.94,52.94s23.7,52.94,52.94,52.94h232.92c5.85,0,10.59,4.74,10.59,10.59s-4.74,10.59-10.59,10.59V278.31z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M96.9,235.92c-17.54,0-31.76-14.22-31.76-31.76s14.22-31.76,31.76-31.76   s31.76,14.22,31.76,31.76l0,0C128.64,221.69,114.43,235.9,96.9,235.92z M96.9,193.57c-5.85,0-10.58,4.74-10.58,10.58   c0,5.85,4.74,10.58,10.58,10.58c5.85,0,10.58-4.74,10.58-10.58l0,0C107.46,198.31,102.73,193.59,96.9,193.57z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M202.76,235.92c-17.54,0-31.76-14.22-31.76-31.76s14.22-31.76,31.76-31.76   s31.76,14.22,31.76,31.76C234.5,221.69,220.29,235.9,202.76,235.92z M202.76,193.57c-5.85,0-10.58,4.74-10.58,10.58   c0,5.85,4.74,10.58,10.58,10.58s10.58-4.74,10.58-10.58c0,0,0,0,0,0C213.33,198.31,208.6,193.59,202.76,193.57z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M202.76,405.35H75.72c-40.94,0-74.13-33.19-74.13-74.13s33.19-74.13,74.13-74.13h232.92   c5.85,0,10.59,4.74,10.59,10.59c0,5.85-4.74,10.59-10.59,10.59H75.72c-29.24,0-52.94,23.7-52.94,52.94   c0,29.24,23.7,52.94,52.94,52.94h127.04c5.85,0,10.59,4.74,10.59,10.59c0,5.85-4.74,10.59-10.59,10.59V405.35z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M96.9,362.96c-17.54,0-31.76-14.22-31.76-31.76s14.22-31.76,31.76-31.76   s31.76,14.22,31.76,31.76C128.64,348.73,114.43,362.94,96.9,362.96z M96.9,320.61c-5.85,0-10.58,4.74-10.58,10.58   s4.74,10.58,10.58,10.58c5.85,0,10.58-4.74,10.58-10.58C107.46,325.36,102.73,320.63,96.9,320.61z"
                />
                <Path
                    stroke={'#48bdad'}
                    strokeWidth={1}
                    d="M202.76,362.96c-17.54,0-31.76-14.22-31.76-31.76s14.22-31.76,31.76-31.76   s31.76,14.22,31.76,31.76C234.5,348.73,220.29,362.94,202.76,362.96z M202.76,320.61c-5.85,0-10.58,4.74-10.58,10.58   s4.74,10.58,10.58,10.58s10.58-4.74,10.58-10.58C213.33,325.36,208.6,320.63,202.76,320.61z"
                />
            </G>
        </Svg>
    );
};

const ITwoStar = () => {
    return (
        <Svg viewBox="0 0 496 512">
            <G>
                <Path
                    stroke={'#f4ad41'}
                    strokeWidth={1}
                    d="M493.04,330.69c-1.2-1.15-2.68-1.97-4.29-2.36l-87.89-20.04l-10.71-17.58l91.7-105.42    c3.53-3.75,3.36-9.65-0.39-13.18c-1.21-1.14-2.71-1.94-4.33-2.31l-148.18-34.3L250.59,5.29c-2.56-4.44-8.23-5.97-12.67-3.41    c-1.42,0.82-2.59,1.99-3.41,3.41l-78.36,130.23L7.96,169.83c-4.99,1.16-8.09,6.15-6.93,11.14c0.34,1.47,1.04,2.83,2.03,3.97    l99.69,114.9L89.59,451.45c-0.49,5.1,3.24,9.63,8.34,10.13c1.54,0.15,3.09-0.09,4.52-0.7l140.1-59.47l11.04,4.72l4.72,5.36    l-7.77,89.67c-0.49,5.1,3.24,9.63,8.34,10.13c1.54,0.15,3.09-0.09,4.52-0.7l83.13-34.73l82.06,34.7    c4.55,2.41,10.19,0.68,12.61-3.87c0.84-1.58,1.2-3.36,1.06-5.14l-7.77-90.08l58.94-67.58c3.55-3.73,3.39-9.64-0.34-13.18    C493.06,330.71,493.05,330.7,493.04,330.69z M109.47,437.69l12.16-140.1c0.24-2.77-0.76-5.5-2.73-7.45l-91.7-105.62l136.98-31.74    c2.6-0.59,4.83-2.27,6.11-4.61l72.25-120.16l72.52,120.48c1.3,2.18,3.43,3.73,5.89,4.29l136.98,31.74l-77.68,89.49l-25.67-42.87    c-2.56-4.44-8.23-5.97-12.67-3.41c-1.42,0.82-2.59,1.99-3.41,3.41l-46.34,77.15l-87.63,20.27c-4.99,1.15-8.11,6.13-6.95,11.13    c0.34,1.47,1.04,2.84,2.03,3.99l35.36,40.73L109.47,437.69z M417.91,402.59c-1.65,1.89-2.46,4.36-2.25,6.86l6.8,78.2l-72.41-30.77    c-2.3-0.96-4.88-0.96-7.18,0l-72.25,30.65l6.8-78.14c0.24-2.77-0.76-5.5-2.73-7.45l-50.97-58.94l76.38-17.28    c2.6-0.59,4.83-2.27,6.11-4.61l40.25-66.88l40.41,67.19c1.32,2.2,3.49,3.75,6,4.29l0,0l76.43,17.68L417.91,402.59z"
                />
            </G>
        </Svg>
    );
};

const IThumbsUp = ({ color }) => {
    return (
        <Svg viewBox="0 0 478.2 478.2" style={{ backgroundColor: '#7242db' }}>
            <G>
                <Path
                    style={{ zIndex: 1 }}
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    d="M457.575,325.1c9.8-12.5,14.5-25.9,13.9-39.7c-0.6-15.2-7.4-27.1-13-34.4c6.5-16.2,9-41.7-12.7-61.5   c-15.9-14.5-42.9-21-80.3-19.2c-26.3,1.2-48.3,6.1-49.2,6.3h-0.1c-5,0.9-10.3,2-15.7,3.2c-0.4-6.4,0.7-22.3,12.5-58.1   c14-42.6,13.2-75.2-2.6-97c-16.6-22.9-43.1-24.7-50.9-24.7c-7.5,0-14.4,3.1-19.3,8.8c-11.1,12.9-9.8,36.7-8.4,47.7   c-13.2,35.4-50.2,122.2-81.5,146.3c-0.6,0.4-1.1,0.9-1.6,1.4c-9.2,9.7-15.4,20.2-19.6,29.4c-5.9-3.2-12.6-5-19.8-5h-61   c-23,0-41.6,18.7-41.6,41.6v162.5c0,23,18.7,41.6,41.6,41.6h61c8.9,0,17.2-2.8,24-7.6l23.5,2.8c3.6,0.5,67.6,8.6,133.3,7.3   c11.9,0.9,23.1,1.4,33.5,1.4c17.9,0,33.5-1.4,46.5-4.2c30.6-6.5,51.5-19.5,62.1-38.6c8.1-14.6,8.1-29.1,6.8-38.3   c19.9-18,23.4-37.9,22.7-51.9C461.275,337.1,459.475,330.2,457.575,325.1z M48.275,447.3c-8.1,0-14.6-6.6-14.6-14.6V270.1   c0-8.1,6.6-14.6,14.6-14.6h61c8.1,0,14.6,6.6,14.6,14.6v162.5c0,8.1-6.6,14.6-14.6,14.6h-61V447.3z M431.975,313.4   c-4.2,4.4-5,11.1-1.8,16.3c0,0.1,4.1,7.1,4.6,16.7c0.7,13.1-5.6,24.7-18.8,34.6c-4.7,3.6-6.6,9.8-4.6,15.4c0,0.1,4.3,13.3-2.7,25.8   c-6.7,12-21.6,20.6-44.2,25.4c-18.1,3.9-42.7,4.6-72.9,2.2c-0.4,0-0.9,0-1.4,0c-64.3,1.4-129.3-7-130-7.1h-0.1l-10.1-1.2   c0.6-2.8,0.9-5.8,0.9-8.8V270.1c0-4.3-0.7-8.5-1.9-12.4c1.8-6.7,6.8-21.6,18.6-34.3c44.9-35.6,88.8-155.7,90.7-160.9   c0.8-2.1,1-4.4,0.6-6.7c-1.7-11.2-1.1-24.9,1.3-29c5.3,0.1,19.6,1.6,28.2,13.5c10.2,14.1,9.8,39.3-1.2,72.7   c-16.8,50.9-18.2,77.7-4.9,89.5c6.6,5.9,15.4,6.2,21.8,3.9c6.1-1.4,11.9-2.6,17.4-3.5c0.4-0.1,0.9-0.2,1.3-0.3   c30.7-6.7,85.7-10.8,104.8,6.6c16.2,14.8,4.7,34.4,3.4,36.5c-3.7,5.6-2.6,12.9,2.4,17.4c0.1,0.1,10.6,10,11.1,23.3   C444.875,295.3,440.675,304.4,431.975,313.4z"
                />
            </G>
        </Svg>
    );
};

const IPost = ({ color }) => {
    return (
        <Svg viewBox="0 0 64 64">
            <G>
                <Path stroke={color} fill={color} strokeWidth={1} d="m8 10h2v2h-2z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m12 10h2v2h-2z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m16 10h2v2h-2z" />
                <Path
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    d="m21 20h-12a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1zm-1 10h-10v-8h10z"
                />
                <Path stroke={color} fill={color} strokeWidth={1} d="m26 20h4v2h-4z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m32 20h16v2h-16z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m26 24h22v2h-22z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m26 28h10v2h-10z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m38 28h6v2h-6z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m8 36h14v2h-14z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m8 40h14v2h-14z" />
                <Path stroke={color} fill={color} strokeWidth={1} d="m8 44h14v2h-14z" />
                <Path stroke={color} fill={color} d="m8 48h14v2h-14z" />
                <Path
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    d="m59 19.091a4.866 4.866 0 0 0 -5 .022v-10.113a3 3 0 0 0 -3-3h-46a3 3 0 0 0 -3 3v46a3 3 0 0 0 3 3h46a3 3 0 0 0 3-3v-17.249l6.83-11.83a5.005 5.005 0 0 0 -1.83-6.83zm-20.155 28.909h-10.845v-10h14.309l-2.639 4.572a.994.994 0 0 0 -.132.564l.212 3.3zm1.289 1.768 1-1.732 1.732 1-1 1.732a1 1 0 0 1 -1.732-1zm4.135-2.232-2.538-1.465-.154-2.4 4.846 2.8zm3.329-2.7-1.732-1 7.5-12.99-1.732-1-7.5 12.99-1.732-1 8.5-14.722 5.2 3zm4.3-19.454.5-.865 5.2 3-.5.866zm-46.898-17.382h46a1 1 0 0 1 1 1v5.032h-48v-5.032a1 1 0 0 1 1-1zm47 47a1 1 0 0 1 -1 1h-46a1 1 0 0 1 -1-1v-38.968h48v5.184l-8.536 14.784h-16.464a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h11.02a3 3 0 0 0 5.58 1.768l1.348-2.336 2.96-1.464a1 1 0 0 0 .423-.4l3.669-6.353zm7.1-30.079-.5.866-5.2-3 .5-.866a3 3 0 0 1 5.2 3z"
                />
            </G>
        </Svg>
    );
};

const IShare = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 512">
            <G transform="translate(0 -0.186)">
                <Path
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    d="M453.12,394.14c22.55-23.09,22.12-60.09-0.96-82.64c-23.09-22.55-60.09-22.12-82.64,0.96   c-22.18,22.71-22.18,58.97,0,81.68c-4.09,1.85-8.04,3.98-11.84,6.36c-13.9-17.06-31.96-30.26-52.43-38.34   c23.77-19.92,32.21-52.77,20.99-81.68l99.62-93.58c26.89,15.55,61.3,6.36,76.85-20.53c15.55-26.89,6.36-61.3-20.53-76.85   c-26.89-15.55-61.3-6.36-76.85,20.53c-9.92,17.15-10.08,38.26-0.43,55.57l-95.3,89.52c-28.39-28.17-74.24-27.99-102.41,0.41   c-1.83,1.84-3.56,3.78-5.18,5.81l-96.51-95.44c15.38-27.1,5.89-61.54-21.22-76.93s-61.54-5.89-76.93,21.22s-5.89,61.54,21.22,76.93   c17.32,9.83,38.55,9.8,55.85-0.08l103.76,102.52c-6.51,26.77,2.74,54.91,23.86,72.59c-21.26,8.38-39.9,22.28-54,40.26   c-4.69-3.19-9.64-5.97-14.8-8.32c22.54-23.1,22.08-60.1-1.02-82.64c-23.1-22.54-60.1-22.08-82.64,1.02   c-22.14,22.7-22.14,58.92,0,81.62c-35.5,16.4-58.22,51.93-58.23,91.03v27.24h510.05v-27.24   C511.38,446.04,488.63,410.52,453.12,394.14z M56.42,164.62c-14.62,0-26.47-11.85-26.47-26.47c0-14.62,11.85-26.47,26.47-26.47   s26.47,11.85,26.47,26.47l0,0C82.79,152.73,71,164.53,56.42,164.62z M411.17,324.78c15.78,0,28.57,12.79,28.57,28.57   c0,15.78-12.79,28.57-28.57,28.57c-15.78,0-28.57-12.79-28.57-28.57l0,0c0.03-15.79,12.86-28.57,28.66-28.54L411.17,324.78z    M454.04,111.63c14.62,0,26.47,11.85,26.47,26.47c0,14.62-11.85,26.47-26.47,26.47c-14.62,0-26.47-11.85-26.47-26.47l0,0   c0.13-14.59,11.97-26.36,26.56-26.41L454.04,111.63z M258.65,263.94c23.58-0.02,42.7,19.08,42.72,42.66s-19.08,42.7-42.66,42.72   c-23.58,0.02-42.7-19.08-42.72-42.66c0.02-23.57,19.12-42.67,42.69-42.69L258.65,263.94z M101.54,324.81   c15.78,0,28.57,12.79,28.57,28.57c0,15.78-12.79,28.57-28.57,28.57s-28.57-12.79-28.57-28.57l0,0   C72.99,337.61,85.77,324.83,101.54,324.81z M31.26,482.51c1.46-38.8,34.09-69.08,72.9-67.63c13.77,0.52,27.09,5.07,38.3,13.09   c-7.68,16.71-11.64,34.89-11.6,53.29v1.36H31.26V482.51z M356.61,482.51H160.72v-1.36c0-54.1,43.86-97.96,97.96-97.96   s97.96,43.86,97.96,97.96v1.36H356.61z M386.48,482.51v-1.36c0.02-19.23-4.32-38.2-12.7-55.51c32.86-20.69,76.27-10.83,96.96,22.03   c6.59,10.47,10.3,22.48,10.77,34.84H386.48z"
                />
                <G transform="translate(5.234 0.186)">
                    <G>
                        <G transform="translate(1.635 2.195)">
                            <Path
                                stroke={color}
                                fill={color}
                                strokeWidth={1}
                                d="M218.95,107.3l-22.32-19.83c25.42-28.61,69.23-31.2,97.84-5.78      c2.04,1.81,3.97,3.74,5.78,5.78l-22.32,19.83c-14.39-16.35-39.3-17.94-55.65-3.56c-1.26,1.11-2.45,2.3-3.56,3.56H218.95z"
                            />
                        </G>
                        <G>
                            <Path
                                stroke={color}
                                fill={color}
                                strokeWidth={1}
                                d="M328.14,66.3c-38.11-43.06-103.92-47.07-146.97-8.95c-3.16,2.8-6.15,5.79-8.95,8.95      l-22.32-19.83c49.08-55.39,133.76-60.5,189.14-11.42c4.03,3.57,7.85,7.39,11.42,11.42L328.14,66.3z"
                            />
                        </G>
                    </G>
                </G>
            </G>
        </Svg>
    );
};

const ILink = () => {
    return (
        <Svg viewBox="0 0 512 400">
            <G transform="translate(-434.49 -12006.368)">
                <G transform="translate(434.018 12006.721)">
                    <Path
                        fill="#FFFFFF"
                        d="M0.08,66.16h512.16l0,0v297.77c0,19.73-16,35.73-35.73,35.73H35.81    c-19.73,0-35.73-16-35.73-35.73V66.16L0.08,66.16z"
                    />
                    <G transform="translate(21.736 24.997)">
                        <Path
                            fill="#3F50F6"
                            d="M145.01,215.29c0,0-17.19,5.7-19.46,21c0,0-2.27,15.29,8.34,23.2     c7.4,5.74,16.86,8.1,26.08,6.52c0,0,31.36-10.09,45.26-23.31c8.12-9.85,7.28-24.29-1.92-33.14c-7.33-8.58-19.44-11.31-29.75-6.71     L145.01,215.29l-7.86-18.03c12.68-6.5,25.99-11.7,39.72-15.53c17.2-2.57,34.47,4.21,45.31,17.81c0,0,21.44,24.63-3.08,58.57     c0,0-13.26,14.72-57.95,27.04c0,0-41.5,7.35-54.87-31.52c0,0-11.02-41.69,30.87-56.37L145.01,215.29z"
                        />
                        <Path
                            fill="#3F50F6"
                            d="M278.55,160.66c0,0-17.19,5.7-19.46,21c0,0-2.27,15.3,8.34,23.2     c7.4,5.74,16.86,8.1,26.08,6.52c0,0,31.36-10.09,45.26-23.31c8.12-9.85,7.28-24.29-1.92-33.14c-7.33-8.58-19.44-11.31-29.75-6.71     L278.55,160.66l-7.86-18.03c12.69-6.5,26-11.7,39.73-15.53c17.2-2.57,34.46,4.21,45.31,17.81c0,0,21.44,24.62-3.08,58.57     c0,0-13.26,14.72-57.95,27.04c0,0-41.5,7.35-54.87-31.52c0,0-11.02-41.69,30.87-56.37L278.55,160.66z"
                        />
                        <Path
                            fill="#B2B9FF"
                            d="M182.26,218.71l97.67-42.57c4.98-2.17,10.78,0.11,12.95,5.09l0,0     c2.17,4.98-0.11,10.78-5.09,12.95l-97.67,42.57c-4.98,2.17-10.78-0.11-12.95-5.09l0,0C175,226.68,177.28,220.88,182.26,218.71z"
                        />
                    </G>
                    <Path
                        fill="#3F50F6"
                        d="M35.81,0.65h440.7c19.73,0,35.73,16,35.73,35.73v41.69l0,0H0.08l0,0V36.38    C0.08,16.65,16.07,0.65,35.81,0.65z"
                    />
                    <Path
                        fill="#C3CAFD"
                        d="M425.12,30.2c6.15,0,11.14,4.99,11.14,11.14s-4.99,11.14-11.14,11.14    c-6.15,0-11.14-4.99-11.14-11.14S418.97,30.2,425.12,30.2C425.12,30.2,425.12,30.2,425.12,30.2z"
                    />
                    <Path
                        fill="#FFFFFF"
                        d="M463.96,30.2c6.15,0,11.14,4.99,11.14,11.14s-4.99,11.14-11.14,11.14    c-6.15,0-11.14-4.99-11.14-11.14S457.81,30.2,463.96,30.2C463.96,30.2,463.96,30.2,463.96,30.2z"
                    />
                    <Path fill="#FFFFFF" d="M172.96,81.03l17.24-25.2h93.85l17.24,25.2H172.96z" />
                    <Path fill="#C3CAFD" d="M44.63,81.03l17.24-27.12h93.85l17.24,27.12H44.63z" />
                </G>
            </G>
        </Svg>
    );
};

const IDomain = () => {
    return (
        <Svg viewBox="0 0 512 472">
            <G transform="translate(0.266 0.724)">
                <Rect x="-0.11" y="67.6" width="477.39" height="396.22" fill="#FFFFFF" />
                <Rect x="0.68" y="0.28" width="510.26" height="65.42" fill="#FF3CA6" />
                <Rect x="478.24" y="65.69" width="32.71" height="405.59" fill="#FFE1F4" />
                <G transform="translate(16.501 25.216)">
                    <G>
                        <G>
                            <Path
                                fill="#FF3CA6"
                                d="M105.63,148.29c-2.24-2.91-6.35-3.6-9.41-1.57c-2.13,1.35-3.34,3.76-3.14,6.27l17.26,56.48      c0,0,6.27,3.14,9.41,0l14.12-23.55l14.12,23.55c3.64,1.77,7.99,1.15,10.98-1.57l1.57-3.14l14.12-50.2      c0.93-4.23-1.74-8.42-5.98-9.35c-0.1-0.02-0.2-0.04-0.3-0.06c0,0-4.7-1.57-6.27,1.57c-1.57,3.14-10.98,39.25-10.98,39.25      l-12.55-18.83c0,0-4.7-3.14-7.85,0c-4.54,6.02-8.72,12.31-12.53,18.82L105.63,148.29z"
                            />
                        </G>
                        <G>
                            <Path
                                fill="#FF3CA6"
                                d="M181.39,148.29c-2.24-2.91-6.35-3.6-9.41-1.57c-2.13,1.35-3.34,3.76-3.14,6.27l17.26,56.48      c0,0,6.27,3.14,9.41,0l14.12-23.55l14.12,23.55c3.64,1.77,7.99,1.15,10.98-1.57l1.57-3.14l14.12-50.2      c0.93-4.23-1.74-8.42-5.98-9.35c-0.1-0.02-0.2-0.04-0.3-0.06c0,0-4.7-1.57-6.27,1.57c-1.57,3.14-10.98,39.25-10.98,39.25      l-12.55-18.83c0,0-4.7-3.14-7.85,0c-4.54,6.02-8.72,12.31-12.53,18.82L181.39,148.29z"
                            />
                        </G>
                        <G>
                            <Path
                                fill="#FF3CA6"
                                d="M255.82,148.29c-2.24-2.91-6.35-3.6-9.41-1.57c-2.13,1.35-3.34,3.76-3.14,6.27l17.26,56.48      c0,0,6.27,3.14,9.41,0l14.12-23.55l14.12,23.55c3.64,1.77,7.99,1.15,10.98-1.57l1.57-3.14l14.12-50.2      c0.93-4.23-1.74-8.42-5.98-9.35c-0.1-0.02-0.2-0.04-0.3-0.06c0,0-4.7-1.57-6.27,1.57c-1.57,3.14-10.98,39.25-10.98,39.25      l-12.55-18.83c0,0-4.7-3.14-7.85,0c-4.54,6.02-8.72,12.31-12.53,18.82L255.82,148.29z"
                            />
                        </G>
                        <G transform="translate(1.199 16.128)">
                            <Rect
                                fill="#FF3CA6"
                                x="99.72"
                                y="234.13"
                                width="32.94"
                                height="32.94"
                            />
                        </G>
                        <Path
                            fill="#FF3CA6"
                            d="M290.01,273.79H157.8c-1.95,0-3.53-1.57-3.53-3.52c0,0,0-0.01,0-0.01v-7.05     c0-1.95,1.57-3.53,3.52-3.53c0,0,0.01,0,0.01,0h132.21c1.95,0,3.53,1.57,3.53,3.52c0,0,0,0.01,0,0.01v7.06     C293.54,272.21,291.96,273.79,290.01,273.79C290.01,273.79,290.01,273.79,290.01,273.79z"
                        />
                        <Path
                            fill="#FF3CA6"
                            d="M354.33,273.79h-44.71c-1.95,0-3.53-1.57-3.53-3.52c0,0,0-0.01,0-0.01v-7.05     c0-1.95,1.57-3.53,3.52-3.53c0,0,0.01,0,0.01,0h44.71c1.95,0,3.53,1.57,3.53,3.52c0,0,0,0.01,0,0.01v7.06     C357.86,272.21,356.29,273.79,354.33,273.79C354.34,273.79,354.33,273.79,354.33,273.79z"
                        />
                        <Path
                            fill="#FF3CA6"
                            d="M352.76,334.98h-44.71c-1.95,0-3.53-1.57-3.53-3.52c0,0,0-0.01,0-0.01v-7.05     c0-1.95,1.57-3.53,3.52-3.53c0,0,0.01,0,0.01,0h44.71c1.95,0,3.53,1.57,3.53,3.52c0,0,0,0.01,0,0.01v7.06     C356.29,333.41,354.72,334.98,352.76,334.98C352.77,334.98,352.76,334.98,352.76,334.98z"
                        />
                        <G transform="translate(1.199 25.482)">
                            <Rect
                                fill="#FF3CA6"
                                x="99.72"
                                y="285.97"
                                width="32.94"
                                height="32.94"
                            />
                        </G>
                        <Path
                            fill="#FF3CA6"
                            d="M290.01,334.98H157.8c-1.95,0-3.53-1.57-3.53-3.52c0,0,0-0.01,0-0.01v-7.05     c0-1.95,1.57-3.53,3.52-3.53c0,0,0.01,0,0.01,0h132.21c1.95,0,3.53,1.57,3.53,3.52c0,0,0,0.01,0,0.01v7.06     C293.54,333.41,291.96,334.98,290.01,334.98C290.01,334.98,290.01,334.98,290.01,334.98z"
                        />
                    </G>
                </G>
                <G transform="translate(52.13 2.606)">
                    <Circle fill="#FFFFFF" cx="305.08" cy="33.66" r="16.35" />
                    <Circle fill="#FFFFFF" cx="350.88" cy="33.66" r="16.35" />
                    <Circle fill="#FFFFFF" cx="396.67" cy="33.66" r="16.35" />
                </G>
            </G>
        </Svg>
    );
};

const IPAddPin = () => {
    return (
        <Svg viewBox="0 0 428 512">
            <G transform="translate(-990.529 -9910.19)">
                <G transform="translate(990.529 9910.19)">
                    <Path
                        fill="#FF9B51"
                        d="M214.42,512L56.98,356.11c0,0-79.34-74.26-47.11-204.12c0,0,40.91-149.69,204.55-150.93    c0,0,172.32-8.66,209.51,178.14c0,0,30.99,107.63-78.1,202.87L214.42,512z"
                    />
                    <Path
                        fill="#FF8B36"
                        d="M213.71,1.06v510.92L47.68,346.63c0,0-62.55-59.54-43.1-172.25    C4.58,174.39,30.24,6.01,213.71,1.06z"
                    />
                    <Text
                        font-size="122.4866px"
                        color="#FFFFFF"
                        stroke={'white'}
                        transform="matrix(1.0021 0 0 1 118.5225 218.6465)"
                        style={{ zIndex: 1 }}
                    >
                        IPs
                    </Text>
                </G>
            </G>
        </Svg>
    );
};

const IBar = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 319">
            <G transform="translate(-693 -12291)">
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="694.37"
                    y="12604.67"
                    width="23.12"
                    height="5.78"
                />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="763.73"
                    y="12413.94"
                    width="23.12"
                    height="196.52"
                />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="1041.16"
                    y="12419.72"
                    width="23.12"
                    height="190.74"
                />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="1179.88"
                    y="12546.87"
                    width="23.12"
                    height="63.58"
                />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="833.09"
                    y="12483.29"
                    width="23.12"
                    height="127.16"
                />
                <Rect x="971.8" y="12483.29" width="23.12" height="127.16" />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="902.45"
                    y="12356.14"
                    width="23.12"
                    height="254.31"
                />
                <Rect
                    stroke={color}
                    fill={color}
                    strokeWidth={1}
                    x="1110.52"
                    y="12292.56"
                    width="23.12"
                    height="317.89"
                />
            </G>
        </Svg>
    );
};

const ITraffic = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 264">
            <G transform="translate(-0.17 0.001)">
                <Path
                    fill="#E8E8E8"
                    d="M2.95,253.38c0,0,9.22-68.93,22.39-100.54l0,0c0-0.02,52.24-128.2,189.23-148.42   c0,0,68.49-10.54,129.07,10.1c0,0,134.34,40.83,162.01,189.67c2.47,16.27,3.64,32.71,3.51,49.17h-82.1c0,0,2.2-34.24-3.95-46.55   c0,0-18-86.05-108.44-117.22c0,0-183.52-45.66-225.66,125.12c-2.33,13.2-3.65,26.55-3.95,39.95H2.95V253.38z"
                />
                <Path
                    fill={color}
                    d="M313.35,89.18c0,0-179.13-41.27-224.77,125.57c-2.34,13.2-3.67,26.56-3.98,39.96H2.51v-1.32   c0,0,0-207.92,208.98-248.31c0,0,71.12-11.42,131.7,9.22"
                />
                <Path
                    fill="#191919"
                    d="M321.8,68.73L279.44,259.7c0,0-32.43,12.09-29.02-19.5L321.8,68.73z"
                />
            </G>
        </Svg>
    );
};

const ITrafficCost = () => {
    return (
        <Svg viewBox="0 0 512 243">
            <Path
                fill="none"
                stroke="#23D3D3"
                strokeWidth="10"
                d="M4.6,239.5c0,0,77.78-119.59,109.22-68.42s39.65,59.3,39.65,59.3s16.25,16.4,35.93-6.45  s50.37-107.32,50.37-107.32s18.98-57.07,43.12-22.58c11.93,17.7,25.2,34.46,39.69,50.13c0,0,23.38,24.23,32.32,6.31  c8.94-17.92,57.04-120.32,57.04-120.32s18.54-47.21,37.78-12.26s57.7,142.89,57.7,142.89"
            />
        </Svg>
    );
};

const LIcon = () => {
    return (
        <View>
            <Svg viewBox="0 0 283.922 283.922">
                <Path
                    d="M266.422,0h-97.625c-9.65,0-17.5,7.851-17.5,17.5c0,9.649,7.85,17.5,17.5,17.5h55.377l-92.375,92.374   c-3.307,3.305-5.127,7.699-5.127,12.375c0,4.676,1.819,9.069,5.125,12.371c3.306,3.309,7.699,5.13,12.375,5.13   c4.674,0,9.069-1.82,12.376-5.127l92.374-92.375v55.377c0,9.649,7.851,17.5,17.5,17.5c9.649,0,17.5-7.851,17.5-17.5V17.5   C283.922,7.851,276.071,0,266.422,0z"
                    stroke="#1157f2"
                    fill={'#1157f2'}
                />
                <Path
                    d="M201.137,253.922H30V82.785h128.711l30-30H15c-8.284,0-15,6.716-15,15v201.137c0,8.284,6.716,15,15,15h201.137   c8.284,0,15-6.716,15-15V95.211l-30,30V253.922z"
                    stroke="#1157f2"
                    fill={'#1157f2'}
                />
            </Svg>
        </View>
    );
};

const LHalfCheck = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 462" style={{ width: 10, height: 10, margin: 2 }}>
            <G transform="translate(0.1 0.1)">
                <Path
                    stroke={color}
                    fill={color}
                    d="M261.03,266.96c-4.23,0-8.29-1.69-11.27-4.71l-95.78-95.78c-6.1-6.38-5.87-16.49,0.51-22.59   c6.18-5.9,15.9-5.9,22.07,0l84.51,84.51L483.88,5.59c6.38-6.1,16.49-5.87,22.59,0.51c5.9,6.17,5.9,15.9,0,22.07L272.32,262.33   c-2.99,3-7.05,4.7-11.29,4.71L261.03,266.96z"
                />
                <Path
                    stroke={color}
                    fill={color}
                    d="M388.74,447.91H58.81c-32.32-0.03-58.51-26.22-58.54-58.54V59.54   C0.25,27.19,26.46,0.94,58.81,0.91c0,0,0,0,0,0h266.14c8.82-0.34,16.24,6.53,16.58,15.35c0.34,8.82-6.53,16.24-15.35,16.58   c-0.41,0.02-0.82,0.02-1.23,0H58.81c-14.72,0.03-26.64,11.98-26.61,26.7c0,0,0,0,0,0v329.83c0.03,14.69,11.92,26.58,26.61,26.61   h329.93c14.69-0.03,26.58-11.92,26.61-26.61V208.45c0.34-8.82,7.76-15.69,16.58-15.35c8.34,0.32,15.03,7.01,15.35,15.35v180.93   C447.25,421.69,421.06,447.89,388.74,447.91z"
                />
            </G>
        </Svg>
    );
};

const LSetting = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 512" style={{ width: 10, height: 10, margin: 2 }}>
            <G>
                <Path
                    stroke={color}
                    fill={color}
                    d="M465.01,343.68c-18.74-10.88-40.82-14.52-62.06-10.21l-77-76.98L403,179.54   c48.31,9.56,95.21-21.86,104.77-70.16c2.65-13.37,2.19-27.17-1.33-40.34c-12.97-47.51-61.99-75.5-109.5-62.53   c-45.01,12.29-72.94,57.2-64.05,103l-77,76.98l-6.25-6.25c-4.06-3.68-10.33-3.38-14.01,0.68c-3.43,3.78-3.43,9.55,0,13.33   l6.25,6.25l-42.02,42l-73.91-73.87l41.98-42.05l4.62,4.62c4.06,3.68,10.33,3.38,14.01-0.68c3.43-3.78,3.43-9.55,0-13.33l-7.76-7.76   c9.54-48.31-21.89-95.21-70.2-104.75C89.5,0.92,69.69,3.5,52.19,12.05c-8.89,4.31-13.47,9.92-13.72,16.61   c0.33,7.46,4.94,14.05,11.83,16.92l26.68,15.34c4.45,2.62,4.45,3.87,4.45,6.18v11.38c0,7.09-0.71,8.32-6.85,11.87l-9.87,5.69   c-1.93,1.11-3.09,1.78-7.63-0.82L30.4,79.89c-5.93-4.53-13.95-5.22-20.57-1.78C3.65,82.82,0.72,90.66,2.3,98.27   c3.39,49.13,45.97,86.2,95.09,82.81c3.84-0.27,7.66-0.78,11.43-1.54l77,76.98l-77.07,77c-48.28-9.55-95.17,21.86-104.71,70.14   c-9.55,48.28,21.86,95.17,70.14,104.71c48.28,9.55,95.17-21.86,104.71-70.14c2.27-11.47,2.26-23.27-0.03-34.74l77-76.98   l77.07,77.02c-9.55,48.31,21.88,95.21,70.19,104.76c19.11,3.78,38.94,1.19,56.44-7.37c8.89-4.31,13.47-9.92,13.72-16.61   c-0.33-7.46-4.94-14.05-11.83-16.92l-26.68-15.34c-4.45-2.62-4.45-3.87-4.45-6.18v-11.38c0-7.09,0.71-8.32,6.85-11.87l9.78-5.69   c1.93-1.11,3.09-1.78,7.63,0.82l26.68,15.34c5.93,4.53,13.95,5.22,20.57,1.78c6.18-4.72,9.1-12.56,7.52-20.17   c-2.06-29.61-18.73-56.25-44.47-71.04L465.01,343.68z M56.66,152.15c-19.64-11.34-32.49-31.57-34.4-54.16l24.95,14.39   c8.21,5.58,18.91,5.9,27.44,0.82l9.87-5.67c11.14-5.19,17.85-16.8,16.77-29.04V67.1c0.1-9.94-5.57-19.04-14.54-23.32L61.87,29.39   c34.67-16.27,75.97-1.36,92.25,33.32c6.56,13.98,8.27,29.74,4.85,44.8l-52.07,52.16C89.8,163.65,71.84,160.96,56.66,152.15z    M360.24,57.36c19.09-33.21,61.48-44.66,94.69-25.57s44.66,61.48,25.57,94.69c-15.19,26.43-45.85,39.84-75.56,33.05l-52.19-51.99   C348.76,90.47,351.44,72.52,360.24,57.36z M151.5,455.62c-19.14,33.17-61.55,44.55-94.73,25.41s-44.55-61.55-25.41-94.73   c15.2-26.35,45.8-39.71,75.47-32.96l52.19,52.1C163,422.51,160.31,440.46,151.5,455.62z M167.97,386.33l-42.07-41.91l217.9-217.9   l42.07,41.98L167.97,386.33z M269.9,312.47l42.02-42l73.91,73.87l-42,42L269.9,312.47z M464.59,400.56   c-8.21-5.58-18.91-5.9-27.44-0.82l-9.87,5.69c-11.14,5.19-17.85,16.8-16.77,29.04v11.38c-0.13,9.92,5.49,19.03,14.43,23.35   l24.93,14.39c-34.67,16.28-75.97,1.36-92.25-33.31c-6.57-13.98-8.27-29.76-4.85-44.83l52.07-52.14   c37.31-8.6,74.53,14.68,83.13,51.99c0.73,3.18,1.24,6.42,1.52,9.67L464.59,400.56z"
                />
                <Path
                    stroke={color}
                    fill={color}
                    d="M385.65,117.73l29.73,17.14c3.06,1.77,6.83,1.77,9.89,0l29.73-17.14   c3.07-1.77,4.96-5.04,4.96-8.58V74.86c0-3.54-1.89-6.81-4.96-8.58l-29.73-17.14c-3.06-1.77-6.83-1.77-9.89,0l-29.73,17.14   c-3.07,1.77-4.96,5.04-4.96,8.58v34.31C380.71,112.7,382.59,115.96,385.65,117.73z M400.51,80.58l19.81-11.43l19.81,11.43v22.86   l-19.81,11.43l-19.81-11.43V80.58z"
                />
                <Path
                    stroke={color}
                    fill={color}
                    d="M126.1,395.23l-29.73-17.14c-3.06-1.76-6.83-1.76-9.89,0l-29.73,17.14   c-3.07,1.77-4.96,5.04-4.96,8.58v34.31c0,3.54,1.89,6.81,4.96,8.58l29.73,17.14c3.06,1.76,6.83,1.76,9.89,0l29.73-17.14   c3.07-1.77,4.96-5.04,4.96-8.58v-34.31C131.06,400.27,129.17,397,126.1,395.23z M111.25,432.38l-19.81,11.43l-19.81-11.43v-22.75   l19.81-11.43l19.81,11.43V432.38z"
                />
                <Path
                    stroke={color}
                    fill={color}
                    d="M211.11,165.6c5.47-0.26,9.7-4.9,9.44-10.37c-0.24-5.11-4.33-9.2-9.44-9.44l0,0   c-5.47,0.26-9.7,4.9-9.44,10.37C201.91,161.27,206,165.36,211.11,165.6z"
                />
            </G>
        </Svg>
    );
};

const LWarn = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 462" style={{ width: 10, height: 10, margin: 2 }}>
            <G transform="translate(0.122 0.1)">
                <G transform="translate(0 0)">
                    <G>
                        <Path
                            stroke={color}
                            fill={color}
                            d="M503.79,371.06L307.96,31.74c-16.65-28.83-53.52-38.7-82.35-22.04     c-9.15,5.29-16.75,12.89-22.04,22.04l-196,339.32c-16.63,28.84-6.74,65.7,22.1,82.34c9.16,5.28,19.54,8.06,30.11,8.06h391.83     c33.29-0.01,60.28-27,60.27-60.29c0-10.57-2.78-20.95-8.06-30.11H503.79z M477.8,416.33c-5.35,9.41-15.37,15.19-26.19,15.13     H59.75c-16.7,0.01-30.24-13.53-30.25-30.23c0-5.32,1.4-10.54,4.06-15.14L229.49,46.75c8.35-14.46,26.84-19.42,41.31-11.08     c4.6,2.66,8.42,6.48,11.08,11.08L477.8,386.09C483.26,395.43,483.26,406.99,477.8,416.33z"
                        />
                    </G>
                </G>
                <G transform="translate(9.774 6.071)">
                    <G>
                        <Rect
                            stroke={color}
                            fill={color}
                            x="230.9"
                            y="145.39"
                            width="30.02"
                            height="150.16"
                        />
                    </G>
                </G>
                <G transform="translate(9.571 13.37)">
                    <G transform="translate(0 0)">
                        <Path
                            stroke={color}
                            fill={color}
                            d="M246.11,318.27c-11.06,0-20.02,8.96-20.02,20.02c0,11.06,8.96,20.02,20.02,20.02     c11.06,0,20.02-8.96,20.02-20.02C266.11,327.24,257.16,318.28,246.11,318.27z"
                        />
                    </G>
                </G>
            </G>
        </Svg>
    );
};

const IGoogle = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 512">
            <G transform="translate(0 0)">
                <Path
                    stroke={color}
                    fill="#FBBD00"
                    d="M121.4,256.51c-0.03-24.23,6.52-48.01,18.95-68.81v-85.46H54.89   c-69.79,91.04-69.79,217.59,0,308.63h85.46V325.4C127.91,304.58,121.36,280.76,121.4,256.51z"
                />
                <Path
                    stroke={color}
                    fill="#0F9D58"
                    d="M256.08,391.19l-59.41,59.41l59.41,59.41c55.82,0.17,110.1-18.24,154.31-52.31v-85.37h-85.37   C304.16,384.71,280.34,391.23,256.08,391.19z"
                />
                <Path
                    stroke={color}
                    fill="#31AA52"
                    d="M140.35,325.31l-85.46,85.46c6.77,8.78,14.1,17.12,21.94,24.96   c47.44,47.7,112,74.44,179.28,74.25v-118.8C208.6,391.17,164.62,366.14,140.35,325.31z"
                />
                <Path
                    stroke={color}
                    fill="#3C79E6"
                    d="M509.59,256.51c0-15.4-1.39-30.78-4.15-45.93l-2.27-12.19H256.08v118.82h120.27   c-11.51,22.9-29.34,42.02-51.38,55.1l85.37,85.37c8.78-6.77,17.12-14.1,24.96-21.94C483.01,388.31,509.75,323.77,509.59,256.51z"
                />
                <Path
                    stroke={color}
                    fill="#CF2D48"
                    d="M351.33,161.29l10.51,10.51l83.96-83.96l-10.51-10.51C387.87,29.61,323.35,2.85,256.08,3   l-59.41,59.41l59.41,59.41C291.83,121.74,326.12,135.95,351.33,161.29z"
                />
                <Path
                    stroke={color}
                    fill="#EB4132"
                    d="M256.08,121.82V3C188.81,2.82,124.25,29.55,76.81,77.25c-7.85,7.84-15.18,16.18-21.94,24.96   l85.46,85.46c24.29-40.8,68.26-65.8,115.73-65.81L256.08,121.82z"
                />
            </G>
        </Svg>
    );
};

const IFacebook = ({ color }) => {
    return (
        <Svg viewBox="0 0 512 512">
            <G>
                <Path
                    stroke={color}
                    strokeWidth={1}
                    fill={'blue'}
                    d="M288,176v-64c0-17.664,14.336-32,32-32h32V0h-64c-53.024,0-96,42.976-96,96v80h-64v80h64v256h96V256h64l32-80H288z"
                />
            </G>
        </Svg>
    );
};

const IYelp = ({ color }) => {
    return (
        <Svg viewBox="0 0 24 24">
            <Path
                stroke={color}
                fill={'blue'}
                d="m12.062 17.662c.038-.934-1.266-1.395-1.829-.671-1.214 1.466-3.493 4.129-3.624 4.457-.347 1 1.28 1.638 2.312 2.024 1.121.42 1.919.591 2.392.51.342-.071.562-.248.67-.533.089-.245.08-5.568.079-5.787z"
            />
            <Path
                stroke={color}
                fill={'blue'}
                d="m11.522.642c-.08-.31-.295-.51-.647-.6-1.037-.272-4.966.838-5.698 1.624-.234.238-.318.515-.248.828l4.985 8c1.018 1.628 2.298 1.139 2.214-.681h-.001c-.066-1.199-.544-8.775-.605-9.171z"
            />
            <Path
                stroke={color}
                fill={'blue'}
                d="m9.413 15.237c.942-.29.872-1.671.07-1.995-2.139-.881-5.06-2.114-5.285-2.114-.876-.052-1.045 1.201-1.134 2.096-.08.81-.084 1.552-.014 2.229.066.714.221 1.443.933 1.485.309-.001 5.383-1.686 5.43-1.701z"
            />
            <Path
                stroke={color}
                fill={'blue'}
                d="m20.514 12.052c.403-.281.342-.7.347-.838-.108-1.024-1.83-3.61-2.692-4.029-.328-.152-.614-.143-.858.029-.323.219-3.24 4.444-3.413 4.619-.567.767.244 1.871 1.092 1.648l-.014.029c.341-.115 5.274-1.282 5.538-1.458z"
            />
            <Path
                stroke={color}
                fill={'blue'}
                d="m15.321 15.586c-.881-.315-1.712.81-1.2 1.581.145.247 2.809 4.705 3.043 4.871.225.191.507.219.83.095.905-.362 2.865-2.876 2.992-3.857.051-.348-.042-.619-.286-.814-.197-.176-5.379-1.876-5.379-1.876z"
            />
        </Svg>
    );
};

const IStarFill = ({ color, fill }) => {
    return (
        <Svg viewBox="0 0 512 512">
            <G transform="translate(-1.475 -1.484)">
                <G transform="translate(0 0)">
                    <Path
                        stroke={color}
                        fill={fill}
                        d="M264.6,426.3l134.6,59.9l-30.1-151c-1.1-5.6,0.6-11.4,4.7-15.5l105.6-105.8l-151.8-30.4    c-5.4-1.1-10-4.8-12.3-9.8L257.6,44L200,173.8c-2.2,5.1-6.8,8.7-12.3,9.8L36,214.1l105.6,105.8c4,4.1,5.8,9.8,4.7,15.5l-30.1,151    l134.6-59.9C255.3,425.3,260,425.3,264.6,426.3z"
                    />
                </G>
            </G>
        </Svg>
    );
};

export {
    LHalfCheck,
    LSetting,
    LWarn,
    LIcon,
    IBar,
    IChatUser,
    ILink,
    IPAddPin,
    IPost,
    IShare,
    ISourceReview,
    IThumbsUp,
    ITraffic,
    ITrafficCost,
    ITwoStar,
    IUserReview,
    IFacebook,
    IGoogle,
    IYelp,
    IStarFill,
    IDomain,
};
